import { render, staticRenderFns } from "./MaleTutorial.vue?vue&type=template&id=c5a2e490&scoped=true&"
import script from "./MaleTutorial.vue?vue&type=script&lang=js&"
export * from "./MaleTutorial.vue?vue&type=script&lang=js&"
import style0 from "./MaleTutorial.vue?vue&type=style&index=0&id=c5a2e490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a2e490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VRadio,VRadioGroup,VTextField,VTextarea})
